module.exports = __webpack_public_path__ + "img/月亮icon.5613ac6e.svg";